'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { isProjectAngleValid, type ProjectAngle } from '@/types/project-angle';
import {
  CompactSection,
  RequiredIndicator,
  ContextCount,
} from './section-components';

interface ProjectAnglesSectionProps {
  angles: ProjectAngle[] | undefined;
  isLoading: boolean;
  projectId: string;
}

export function ProjectAnglesSection({
  angles,
  isLoading,
  projectId,
}: ProjectAnglesSectionProps) {
  const t = useTranslations('project');

  const validAngles = useMemo(
    () =>
      angles?.filter((a) => a.attributes.file_url && isProjectAngleValid(a)) ||
      [],
    [angles]
  );

  return (
    <CompactSection
      title={t('angles')}
      href={`/project/${projectId}/angles`}
      contextContent={
        validAngles.length > 0 ? (
          <ContextCount count={validAngles.length} />
        ) : !isLoading ? (
          <RequiredIndicator />
        ) : undefined
      }
    />
  );
}
